module.exports = __webpack_public_path__ + "static/media/Stride-270x270.25e41bfe.png";